<div class="m-t-10"></div>
<mat-accordion class="m-l-10 m-r-10">
    <div *ngIf="!serviceNotFound">
        <cdk-virtual-scroll-viewport class="sh-virtual-scroll" itemSize="100" (scrolledIndexChange)="handler($event)" onmouseover="this.style.overflow='scroll'">
            <ng-container *cdkVirtualFor="let service of services">
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    style="border: 5px;">

                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-sm-1">
                                        <div class="row p-t-20">
                                            <div class="col-sm-6 service-date-month">{{service.Date| date |
                                                datemonthformat}}
                                            </div>
                                            <div class="col-sm-6 service-date-year">{{service.Date| date| yearformat }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-1 p-t-20 p-l-10 m-b-15">
                                        <div *ngIf="service.repairer.brand === 'AP'">
                                            <img src="../../../assets/images/AP.svg" width="60px" height="60px"
                                                alt="">
                                        </div>
                                        <div *ngIf="service.repairer.brand === 'AC'">
                                            <img src="../../../assets/images/AC.svg" width="60px" height="60px"
                                                alt="">
                                        </div>
                                        <div *ngIf="service.repairer.brand === 'DS'">
                                            <img src="../../../assets/images/DS.svg" width="60px" height="60px" alt="">
                                        </div>
                                        <div *ngIf="service.repairer.brand === 'OP'">
                                            <img src="../../../assets/images/OP.svg" width="60px" height="60px" alt="">
                                        </div>
                                        <div *ngIf="service.repairer.brand === 'OV'">
                                            <img src="../../../assets/images/OV.svg" width="60px" height="60px" alt="">
                                        </div>
                                        <div *ngIf="service.repairer.brand === 'VX'">
                                            <img src="../../../assets/images/VX.svg" width="60px" height="60px" alt="">
                                        </div>
                                    </div>
                                    <div class="m-l-20 "></div>
                                    <div class="col-sm-3 m-l-15 p-t-15">
                                        <div class="service-center-name" style="height: auto;">{{service.repairer.name}}</div>
                                        <div class="service-center-address" style="height: auto;">
                                            {{service.repairer.address}}
                                        </div>
                                        <div class="service-center-address">{{service.repairer.zipCode}}
                                            {{service.repairer.city}}</div>
                                    </div>
                                    <div class="col-sm-1">
                                        <span class="service-badge m-t-25">{{service.mileage.value | number:'':
                                            shlocale}}
                                            {{service.mileage.unit}}</span>
                                    </div>
                                </div>
                            </div>
                        </mat-panel-title>
                        <mat-panel-description style="max-width:30%;">
                            <div class="container-fluid">
                                <div class="row" *ngIf="!isReadOnly && customerVeficationRetryCount > 0">
                                    <div class="col-sm-10"></div>
                                    <div class="col-sm-2 p-t-35 " *ngIf="service.accessServiceEdit">
                                        <span (click)="editBtnClicked(service.id ,service.accessServiceEdit)"
                                            class=" m-l-5" style="color:#1F54A3 ">
                                            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                                        </span>
                                        <span class="line-separation-servcie-history p-t-10 "></span>
                                    </div>
                                    <div class="col-sm-2 p-t-35 " *ngIf="!service.accessServiceEdit">
                                        <span style="cursor: not-allowed" class=" m-l-5">
                                            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                                        </span>
                                        <span class="line-separation-servcie-history p-t-10 "></span>
                                    </div>
                                </div>
                                <div class="row" *ngIf="isReadOnly">
                                    <div class="col-sm-10"></div>
                                    <div class="col-sm-2 p-t-35">
                                        <span style="cursor: not-allowed" class="m-l-5">
                                            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                                        </span>
                                        <span class="line-separation-servcie-history p-t-10 "></span>
                                    </div>
                                </div>
                            </div>
                        </mat-panel-description>
                    </mat-expansion-panel-header>


                    <br>
                    <div class="row horizontal-line-separation"></div>
                    <div class="container-fluid m-t-20">

                        <div class="row " style="min-height: 120px;">
                            <div *ngIf="vehicleBrandIsNotOV" class="col-sm-1">
                                <div *ngIf="service.usage === 'NORMAL'">
                                    <div class="maintenance-status-badge badge-text ">Normal</div>
                                </div>
                                <div *ngIf="service.usage === 'SEVERE'">
                                    <div class="maintenance-status-badge badge-text ">Severe</div>
                                </div>
                            </div>
                            <div style="margin-left: 40px;"></div>
                            <div class="col-sm-5 m-l-20" style="margin-left: 50px;">
                                <div class="service-history-title" translate>dimbo.i18n.header.MaintenanceOperation
                                </div>
                                <div class="service-history-description" *ngFor="let operation of service.operations">
                                    {{operation.label}}</div>
                            </div>
                            <div class="col-sm-4">
                                <mat-form-field class="example-full-width float-right">
                                    <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                    <textarea matInput [value]="service.comment" disabled></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row horizontal-line-separation" style="margin-left: 160px;"></div>

                        <div class="row" style="min-height: 150px; margin-left: 25px;">
                            <div class="col-sm-1"></div>
                            <div style="margin-left: 30px;"></div>
                            <div class="col-sm-8 m-l-20">
                                <div class="row">
                                    <div class="col-sm-12 m-t-15 service-history-title" translate>
                                        dimbo.i18n.header.AntiPerforation</div>
                                    <div class="col-sm-4 m-t-15" translate >dimbo.i18n.header.AntiPerforationInspection
                                    </div>
                                    <div class="p-t-20">
                                        <span *ngIf="service.antiPerforation.period" class="anti-year-badge">
                                            <span class="perforation-text">&#10003; {{service.antiPerforation.period}}
                                               <span translate>dimbo.i18n.label.Year</span></span>
                                        </span>
                                    </div>
                                    <span class="p-l-50" translate>dimbo.i18n.label.AntiPerforationIssueDetected</span>
                                    <span class="m-l-20">
                                        <mat-slide-toggle
                                            [checked]="service.antiPerforation.issueDetected === true ? true : false"
                                            disabled>
                                        </mat-slide-toggle>
                                    </span>

                                    <div class="col-sm-12 m-t-15">
                                        <mat-form-field class="example-partial-width">
                                            <mat-label translate>dimbo.i18n.label.Comment</mat-label>
                                            <div *ngIf="service.antiPerforation.comment!== undefined ">
                                                <textarea matInput [value]="service.antiPerforation.comment"
                                                    disabled></textarea>
                                            </div>
                                            <div *ngIf="service.antiPerforation.comment == undefined ">
                                                <textarea matInput disabled></textarea>
                                            </div>
                                        </mat-form-field>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>



                </mat-expansion-panel>
                <div class="m-t-10"></div>
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </div>

</mat-accordion>

<div *ngIf="serviceNotFound" class="vehicle-info-description float-left">
</div>